import { database, storage } from '../firebaseApp';

class CaazamProfileError extends Error {
    constructor(code) {
        super(code); 
        this.name = this.constructor.name;
        this.code = code;
    }
};

export default class CaazamUser {
    constructor(authUser) {
        this.authUser = authUser;
    }

    isValidProfileImage() {
        if (!this.authUser) {
            return false;
        }

        let photoURL = this.authUser.photoURL;
        if(!photoURL) {
            return false;
        }
        let invlaid = (photoURL.indexOf('google') >= 0 ||
            photoURL.indexOf('facebook') >= 0 ||
            photoURL.indexOf('http') >= 0 ||
            photoURL === '' ||
            photoURL === null
        )
        return !invlaid;
    }


    getProfileImage(callback) {
        if (!this.isValidProfileImage()) {
            callback(null);
            return;
        }

        let ref = storage.ref('profileImages').child(this.authUser.photoURL);

        ref.getDownloadURL().then(url => {
            callback(url);
        }).catch(error => {
            callback(null, error);
        })
    }

    setProfileImage(image, progress, callback) {
        if (!image) {
            console.error('CaazamUser:setProfileImage image is null');
            return;
        }

        const progressReport = progress || (() => { })

        //TBD: compress image if larger than allowed max size

        let imagePath = this.authUser.uid + '/' + Date.now() + '.jpg';
        let metadata = {
            contentType: 'image/jpeg',
        };

        var uploadTask = storage.ref('profileImages').child(imagePath).putString(image, 'data_url',metadata);

        // Listen for state changes, errors, and completion of the upload.
        let unsubscribe = uploadTask.on('state_changed',
            (snapshot) => {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('CaazamUser:setProfileImage Upload is ' + progress + '% done');
                progressReport(progress * 0.25);
            }, function (error) {
                console.log('CaazamUser:setProfileImage Error in profile photo upload', error);
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;

                    case 'storage/canceled':
                        // User canceled the upload
                        break;

                    case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                    default:
                        break;
                }
                unsubscribe();
                callback(error);
            }, () => {
                console.log('CaazamUser:setProfileImage Upload is complete');
                unsubscribe();
                progressReport(50);
                // Upload completed successfully, now we can start the server processing
                this._startProfileProcessing(imagePath).then(() => {
                    progressReport(66);
                    return this._observerProfileResults(progressReport);
                }).then(() => {
                    progressReport(100);
                    console.log('CaazamUser:setProfileImage updaing new profileURL',imagePath);
                    return this.authUser.updateProfile({ photoURL: imagePath});
                }).then(()=> {
                    console.log('CaazamUser:setProfileImage DONE');
                    callback();
                }).catch(error => {
                    console.error('CaazamUser:setProfileImage ERROR',error);
                    callback(error);
                });
            });
    }

    _startProfileProcessing = (imagePath) => {
        let request = {
            uuid: this.authUser.uid,
            name: 'no-name',
            newProfileImageUrl: imagePath,
            currentProfileImageUrl: 'no-url',
            isMainProfileImage: true,
        }

        console.log('CaazamUser:_startProfileProcessing',request);
        return database.ref("caazamProfileQueue/tasks").push(request);
    }

    _observerProfileResults = (progressReport) => {
        return new Promise((resolve,reject)=>{
            console.log("starting to listen to mailbox for profile updates for", this.authUser.uid);
            const ref = database.ref("mailbox").child(this.authUser.uid);
            ref.on('child_added', (snapshot) => {

                switch (snapshot.val().message) {
                    case 'profile_image_error':
                        let caazamError = snapshot.val().error
                        snapshot.ref.remove();
                        console.log('Error in profile image process for', this.authUser.uid, caazamError);
                        ref.off('child_added');
                        let newError = new CaazamProfileError(caazamError);
                        reject(newError);
                        break;
                    case 'profile_image_detected':
                        snapshot.ref.remove();
                        console.log('Profile image detected for', this.authUser.uid);
                        progressReport(80);
                        break;
                    case 'profile_image_done':
                        snapshot.ref.remove();
                        console.log('Profile image process compelte for', this.authUser.uid);
                        ref.off('child_added');                        
                        resolve('done');
                        break;
                    default:
                        console.log("Recevied unknown message for profile process - ignoring", snapshot.val().message, snapshot.val().error);
                        break;
                }

            });

        });
    
    }
}


// WEBPACK FOOTER //
// ./src/CaazamModel/CaazamUser.js